import { http } from "../httpHandler";
import { links } from "@/constants";
import type { TServerErrorResponse } from "@/types";

export interface AttachmentInitResponse {
  uploadId: string;
  containerUrl: string;
  sasToken: string;
  sasExpiry: string;
  blobPathPrefix: string;
}

export interface RegisterAttachmentRequest {
  uploadId: string;
  blobName: string;
  filename: string;
  mimeType: string;
  sizeBytes: number;
}

export type AttachmentStatus = "pending" | "ready" | "error";

export interface AttachmentCreateResponse {
  attachmentId: string;
  status: AttachmentStatus;
}

export interface AttachmentStatusResponse {
  attachmentId?: string;
  status: AttachmentStatus;
  content?: string;
  pageCount?: number;
  filename?: string;
  mimeType?: string;
  errorCode?: string;
  errorMessage?: string;
  extractedAt?: string;
}

export const initAttachmentUpload =
  async (): Promise<AttachmentInitResponse> => {
    try {
      const res = await http.post<AttachmentInitResponse>(
        links.attachment.initDirect,
        {},
      );
      return res.data;
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };

export const registerAttachment = async (
  body: RegisterAttachmentRequest,
): Promise<AttachmentCreateResponse> => {
  try {
    const res = await http.post<AttachmentCreateResponse>(
      links.attachment.register,
      body,
    );
    return res.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAttachmentStatus = async (
  id: string,
): Promise<AttachmentStatusResponse> => {
  try {
    const res = await http.get<AttachmentStatusResponse>(
      links.attachment.byId(id),
    );
    return res.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteAttachment = async (id: string): Promise<void> => {
  try {
    await http.delete(links.attachment.byId(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
